import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

const cardCarouselStoreConfig = {
  id: 'card_carousel',
  initialState: {
    listInfo: null
  },
  methods: (set, get) => ({
    setListInfo: (listInfo) => {
      set({ listInfo });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

// Store instance cache to prevent creating multiple instances for the same component
const storeInstances = new Map();

// Function to create or get existing store instance
const createCardCarouselStoreInstance = (
  componentId,
  isGlobal = false,
  cacheConfig
) => {
  const cacheKey = `${componentId}_${isGlobal ? 'global' : 'regular'}`;

  if (storeInstances.has(cacheKey)) {
    return storeInstances.get(cacheKey);
  }

  const config = {
    ...cardCarouselStoreConfig,
    id: `card_carousel_${componentId}`
  };

  if (cacheConfig?.scope === 'global') {
    config.cache.scope = 'global';
  }

  const storeInstance = createStore(config);
  storeInstances.set(cacheKey, storeInstance);
  return storeInstance;
};

export const useCardCarouselStore = createStore(cardCarouselStoreConfig);

export const useGlobalCardCarouselStore = (props = {}) => {
  const { id, cacheConfig } = props;

  const finalComponentId = id || 'default';

  if (finalComponentId) {
    return createCardCarouselStoreInstance(
      finalComponentId,
      false,
      cacheConfig
    );
  }

  return useCardCarouselStore;
};
